import { AxiosResponse } from 'axios';

import { http } from '@/api/http';
import { IGetParams, IListResponse, IPaginatedListResponse } from '@/api/types';
import { ApiVersion } from '@/config';
import { IPointLayer, IPolygonLayer } from '@/models';

export const MapLayerApi = {
  getPolygonLayers: (
    params?: IGetParams,
  ): Promise<AxiosResponse<IListResponse<IPolygonLayer>>> => {
    return http.get(`api/${ApiVersion.V1}/map-layers/polygons`, { params });
  },

  getPointLayers: (
    params?: IGetParams,
  ): Promise<AxiosResponse<IPaginatedListResponse<IPointLayer>>> => {
    return http.get(`api/${ApiVersion.V2}/map-layers/points`, { params });
  },

  createPointLayer: (
    data: IPointLayer,
  ): Promise<AxiosResponse<IPointLayer>> => {
    return http.post(`api/${ApiVersion.V2}/map-layers/points`, data);
  },

  deletePointLayer: (id: string): Promise<AxiosResponse<void>> => {
    return http.delete(`api/${ApiVersion.V2}/map-layers/points/${id}`);
  },

  updatePointLayer: (
    id: string,
    data: Partial<IPointLayer>,
  ): Promise<AxiosResponse<IPointLayer>> => {
    return http.put(`api/${ApiVersion.V2}/map-layers/points/${id}`, data);
  },
};
